<div class="loading" [hidden]="!show_loading">
  <div class="loader">Loading...</div>
</div>

<app-new-version-checker />

@if (timeTrackingStatus) {
  <div class="timeTrackingTimer">
    <div style="vertical-align: middle">
      <app-timer
        style="display: inline-block"
        [timeTrackingStatus]="timeTrackingStatus"
      ></app-timer>
    </div>
  </div>
}

@if (sharedDataService.data.user_type == 2) {
  <div class="mobile-app-ad">
    <img src="assets/img/app-ad-4.png" height="86" />
  </div>
}

<ch-file-preview
  class="loading"
  style="background: rgba(226, 228, 230, 0.97); z-index: 1000"
  [hidden]="!isFilePreviewOpened"
></ch-file-preview>

<div
  class="adjust-body-for-alerts"
  [ngClass]="{
    'has-message':
      sharedDataService.data.user_type == 1 &&
      sharedDataService.data.error_status != null &&
      sharedDataService.data.error_status > 0,
  }"
>
  <!-- <div class="full-top-alert" style="background: #ffe281; color: black">
  debug: data | json
</div> -->

  @if (
    sharedDataService.data?.user_type == 1 &&
    sharedDataService.data?.access_level == 1
  ) {
    <div>
      <!-- Trial ending -->
      @if (
        sharedDataService.hasErrorStatus(
          SubscriptionErrorStatus.SUBSCRIPTION_TRIAL_ENDING
        ) &&
        sharedDataService.subscriptionType == "paid" &&
        !sharedDataService.data.stripe_subscription_status != "canceled"
      ) {
        <div class="full-top-alert">
          <strong class="title">Trial Ending</strong>. Please proceed to the
          <a [routerLink]="[]" (click)="navigateToPracticeInfo()"
            >Practice Info</a
          >
          and add a payment method in order to continue using Client Hub after
          the trial.
        </div>
      }
      <!-- Past Due -->
      @if (
        sharedDataService.data.error_status.includes("past_due") &&
        sharedDataService.subscriptionType != "free"
      ) {
        <div class="full-top-alert">
          <strong class="title">Your account is past due</strong>. Please
          <a [routerLink]="[]" (click)="goToCustomerPortal()"
            >add your payment info</a
          >
          in order to continue using Client Hub.
        </div>
      }
      @if (
        sharedDataService.data.error_status.includes("payment_failed") &&
        sharedDataService.subscriptionType != "free"
      ) {
        <div class="full-top-alert">
          <strong class="title"
            >Your last Client Hub invoice payment failed</strong
          >. Please
          <a [routerLink]="[]" (click)="goToCustomerPortal()"
            >go to the self-service billing portal</a
          >
          to update your payment method and reattempt payment.
        </div>
      }
    </div>
  }

  <div
    (window:resize)="onResize($event)"
    class="fake-body d-flex"
    [ngClass]="{ 'menu-open': menuOpen }"
  >
    <div
      class="sidebar"
      [ngClass]="{ 'sidebar-client': sharedDataService.data.user_type == 2 }"
    >
      @if (sharedDataService.data.user_type == 1) {
        <div class="sidebar-left">
          <div class="sidebar-left-top">
            <div class="sidebar-logo" routerLink="/practice/workspaces">
              <svg
                width="29"
                height="30"
                viewBox="0 0 29 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27.919 3.84468C27.391 1.24646 24.865 -0.433054 22.282 0.0980731C19.699 0.629201 18.0293 3.17 18.5573 5.76822C18.6572 6.28499 18.8713 6.7587 19.1139 7.18934L17.2587 10.0172C16.3453 9.78756 15.3749 9.73014 14.3902 9.93111C13.2058 10.1751 12.1925 10.7493 11.3648 11.5101L8.45358 9.55788C8.56775 9.0124 8.56775 8.43821 8.45358 7.86402C7.98264 5.5529 5.74213 4.06 3.44452 4.53371C1.14692 5.02177 -0.337242 7.27547 0.133695 9.5866C0.604632 11.8977 2.84515 13.3906 5.14275 12.9169C5.71358 12.8021 6.2416 12.5724 6.684 12.2566L9.59525 14.1945C9.22421 15.2567 9.11004 16.4338 9.35264 17.6109C9.60952 18.8885 10.2517 19.9938 11.108 20.8551L9.92348 22.6495C9.43827 22.5346 8.93879 22.5059 8.41077 22.6064C6.41285 23.0227 5.11421 24.9893 5.51379 27.0133C5.92765 29.023 7.88275 30.3293 9.89493 29.9273C11.8928 29.5111 13.1915 27.5444 12.7919 25.5204C12.692 24.9893 12.4494 24.5443 12.1497 24.128L13.3342 22.3337C14.4616 22.7787 15.7174 22.9509 16.9875 22.6782C20.4839 21.9604 22.7529 18.5153 22.0251 14.9984C21.8253 14.0079 21.3972 13.1322 20.8121 12.3714L22.6673 9.54353C23.1668 9.60095 23.6663 9.60095 24.18 9.50047C26.7773 8.98369 28.447 6.44289 27.919 3.84468ZM4.60046 10.2613C3.75848 10.4479 2.93077 9.88805 2.75953 9.04111C2.58828 8.19418 3.13057 7.3616 3.97254 7.18934C4.81452 7.01709 5.64223 7.56257 5.81348 8.4095C5.98473 9.25643 5.44244 10.089 4.60046 10.2613ZM9.46681 27.8172C8.61056 27.9894 7.78285 27.444 7.6116 26.5827C7.44035 25.7214 7.98264 24.8888 8.83889 24.7166C9.69514 24.5443 10.5229 25.0898 10.6941 25.9511C10.8796 26.798 10.3231 27.6306 9.46681 27.8172ZM16.3453 19.5201C14.5758 19.879 12.849 18.7306 12.4922 16.9506C12.1355 15.1706 13.2771 13.4337 15.0467 13.0748C16.8163 12.7159 18.5431 13.8643 18.8998 15.6443C19.2566 17.4243 18.1149 19.1612 16.3453 19.5201ZM23.5806 6.4716C22.6673 6.65822 21.7683 6.06967 21.5827 5.15096C21.3972 4.23226 21.9823 3.3279 22.8957 3.14129C23.809 2.95468 24.708 3.54322 24.8936 4.46193C25.0791 5.38064 24.494 6.28499 23.5806 6.4716Z"
                  fill="#0075FF"
                />
              </svg>
            </div>
            @if (!clientListOpen && this.router.url.includes("workspaces")) {
              <a
                class="sidebar-icon mb-5"
                (click)="toggleClientList()"
                tooltip="Show Client List"
                placement="right"
              >
                <i class="tio-last_page"></i>
              </a>
            }
            <div
              class="sidebar-icon sidebar-notifications"
              (click)="openNotifications()"
              tooltip="Notifications"
              placement="right"
            >
              <div
                class="notifications-bell has-notifications"
                [ngClass]="{ 'has-notifications': hasUnreadNotifications }"
              >
                <span class="counter"></span>
                <i class="tio-notifications"></i>
              </div>
            </div>
          </div>
          @if (sharedDataService.data.user_type == 1) {
            <div class="sidebar-left-middle">
              <a
                class="sidebar-icon"
                routerLink="/practice/workspaces"
                routerLinkActive="active"
                tooltip="Clients & Workspaces"
                placement="right"
              >
                <i class="tio-group_equal" style="font-size: 26px"></i>
              </a>
              @if (isEmailAvailable) {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/email"
                  routerLinkActive="active"
                  tooltip="Inbox"
                  placement="right"
                >
                  <i class="tio-inbox" style="font-size: 26px"></i>
                  <!-- <div
                  class="notification"
                  *ngIf="unreadThreadsCount != null && unreadThreadsCount > 0"
                  >
                  {{ unreadThreadsCount }}
                </div> -->
                </a>
              }
              @if (
                sharedDataService.subscriptionType == SubscriptionType.FREE
              ) {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/getting-started"
                  routerLinkActive="active"
                  tooltip="Getting Started"
                  placement="right"
                >
                  <i class="tio-notice"></i>
                </a>
              }
              @if (
                sharedDataService.subscriptionType != SubscriptionType.FREE
              ) {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/dashboards"
                  routerLinkActive="active"
                  tooltip="Dashboards"
                  placement="right"
                >
                  <i class="tio-dashboard"></i>
                </a>
              }
              @if (
                sharedDataService.subscriptionType != SubscriptionType.FREE
              ) {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/templates"
                  routerLinkActive="active"
                  tooltip="Templates"
                  placement="right"
                >
                  <i class="tio-files"></i>
                </a>
              }
              <!-- <a
            class="sidebar-icon"
            routerLink="/practice/manage-apps"
            routerLinkActive="active"
            tooltip="Apps & Resources"
            placement="right"
            *ngIf="sharedDataService.subscriptionType != SubscriptionType.FREE"
            >
            <i class="tio-menu_vs"></i>
          </a> -->
              @if (userPermissions?.role == ROLE_ADMIN) {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/practice-info"
                  routerLinkActive="active"
                  tooltip="Manage Practice"
                  placement="right"
                >
                  <i class="tio-briefcase"></i>
                </a>
              }
              <!-- <a
          class="sidebar-icon"
          routerLink="/practice/client-onboarding-game-plan"
          routerLinkActive="active"
          >
          <span>Client Onboarding Game Plan</span>
        </a> -->
              @if (
                userPermissions?.role == ROLE_ADMIN ||
                userPermissions.permissions.includes(
                  PERMISSION_GENERAL_ACCESS_SETUP_AND_SETTINGS
                )
              ) {
                <a
                  class="sidebar-icon"
                  tooltip="Setup & Settings"
                  placement="right"
                  routerLink="/practice/setup-and-settings"
                  [routerLinkActiveOptions]="{ exact: false }"
                  routerLinkActive="active"
                >
                  <i class="tio-settings"></i>
                </a>
              }
              @if (sharedDataService.subscriptionType != "free") {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/welcome"
                  routerLinkActive="active"
                  tooltip="Get Help"
                  placement="right"
                >
                  <i class="tio-help"></i>
                </a>
              }
              @if (sharedDataService.subscriptionType == "free") {
                <div class="btn-group" dropdown [autoClose]="true">
                  <a
                    dropdownToggle
                    class="sidebar-icon"
                    tooltip="Get Help"
                    placement="right"
                  >
                    <i class="tio-support_vs"></i>
                  </a>
                  <ul
                    id="dropdown-basic"
                    *dropdownMenu
                    class="dropdown-menu"
                    role="menu"
                    aria-labelledby="button-basic"
                  >
                    <li (click)="openWelcomeVideo()" role="menuitem">
                      <a class="dropdown-item">Welcome Video</a>
                    </li>
                    <li data-reamaze-lightbox="kb" role="menuitem">
                      <a class="dropdown-item">Frequently Asked Questions</a>
                    </li>
                  </ul>
                </div>
              }

              @if (sharedDataService.data.access_level == 1) {
                <a
                  class="sidebar-icon"
                  routerLink="/practice/referral-program"
                  routerLinkActive="active"
                  tooltip="Referral Program"
                  placement="right"
                >
                  <i class="tio-user_add"></i>
                </a>
              }

              <a
                class="sidebar-icon"
                routerLink="/practice/user-survey"
                routerLinkActive="active"
                tooltip="User Survey"
                placement="right"
              >
                <i class="tio-survey"></i>
              </a>
            </div>
          }
          <div class="sidebar-left-bottom">
            <!-- <a class="sidebar-icon" routerLink="/practice/welcome" routerLinkActive="active" tooltip="Settings" placement="right">
      <i class="tio-settings"></i>
    </a> -->
            <div
              class="user-dropdown"
              dropdown
              [dropup]="true"
              [autoClose]="true"
              [insideClick]="true"
            >
              <div dropdownToggle class="dropdown-toggle">
                <div
                  class="avatar avatar-32"
                  [style.background-image]="'url(' + user.pictureUrl + ')'"
                  style="background-size: contain; background-position: center"
                ></div>
              </div>
              <ul
                *dropdownMenu
                class="dropdown-menu dropown-user-sidebar"
                role="menu"
              >
                <li>
                  <a (click)="openMyAccountModal()"
                    ><i class="feather user"></i> My Account</a
                  >
                </li>
                <li>
                  <a (click)="openMyDevicesModal()"
                    ><i class="feather smartphone"></i> My Devices</a
                  >
                </li>
                <li>
                  <a (click)="openGeneralNotificationSettingsModal()">
                    <i class="feather bell"></i> Notification Settings
                  </a>
                </li>
                <li role="separator" class="divider"></li>
                <li>
                  <a (click)="logout()"
                    ><i class="feather log-out"></i> Logout</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      }
      <app-notifications
        (closeNotifications)="closeNotifications()"
        (notificationsLoaded)="notificationsLoaded($event)"
        [ngClass]="{
          open: notificationsOpen,
          'client-view-notifications': sharedDataService.data.user_type == 2,
        }"
      >
      </app-notifications>
      @if (isRouteOnWorkspaces) {
        <div
          class="sidebar-right"
          [ngClass]="{
            'client-view-sidebar': sharedDataService.data.user_type == 2,
            hidden: !clientListOpen,
          }"
        >
          <!-- Practice logo if client -->
          @if (sharedDataService.data.user_type == 2) {
            <div class="d-flex align-items-center">
              <div class="logo-wrapper flex-grow">
                @if (company.accounting_company.logo !== null) {
                  <div class="practice-logo-name">
                    <img
                      placement="bottom"
                      tooltip="{{ company.accounting_company.name }}"
                      src="{{ company.accounting_company.logo }}"
                      alt="{{ company.accounting_company.name }}"
                    />
                  </div>
                }
                @if (company.accounting_company.logo == null) {
                  <h1 class="company-name-client-view">
                    <span
                      placement="bottom"
                      tooltip="{{ company.accounting_company.name }}"
                      >{{ company.accounting_company.name }}</span
                    >
                  </h1>
                }
                <i
                  class="feather menu menu-icon"
                  (click)="menuOpen = !menuOpen"
                ></i>
              </div>
              <div
                class="sidebar-icon sidebar-notifications"
                (click)="openNotifications()"
              >
                <div
                  class="notifications-bell has-notifications"
                  [ngClass]="{ 'has-notifications': hasUnreadNotifications }"
                >
                  <span class="counter"></span>
                  <i class="tio-notifications"></i>
                </div>
              </div>
            </div>
          }
          <!-- Social media icons if client -->
          @if (sharedDataService.data.user_type == 2) {
            <div class="social-media-icons">
              @if (company.accounting_company.url) {
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="{{ company.accounting_company.url }}"
                  ><i class="tio-link" aria-hidden="true"></i
                ></a>
              }
              @if (company.accounting_company.facebook) {
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="{{ company.accounting_company.facebook }}"
                  ><i class="tio-facebook_square" aria-hidden="true"></i
                ></a>
              }
              @if (company.accounting_company.linkedin) {
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="{{ company.accounting_company.linkedin }}"
                  ><i class="tio-linkedin_square" aria-hidden="true"></i
                ></a>
              }
              @if (company.accounting_company.twitter) {
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="{{ company.accounting_company.twitter }}"
                >
                  <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="vertical-align: -1px"
                  >
                    <g clip-path="url(#clip0_5_2)">
                      <path
                        d="M14.16 0H16.92L10.86 6.9L17.94 16.26H12.384L8.034 10.572L3.054 16.26H0.293998L6.714 8.88L-0.0660019 0H5.628L9.558 5.196L14.16 0ZM13.194 14.64H14.724L4.824 1.56H3.18L13.194 14.64Z"
                        fill="black"
                        style="fill: black; fill-opacity: 1"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_5_2">
                        <rect
                          width="18"
                          height="16.26"
                          fill="white"
                          style="fill: white; fill-opacity: 1"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              }
            </div>
          }
          <!-- Client View workspace list -->
          @if (sharedDataService.data.user_type == 2) {
            <div class="workspace-list-plus-ad-client-only">
              <div class="fixed-workspace-list">
                <div class="clients-list-header">
                  <div class="title">
                    <div class="text d-flex">
                      <div style="flex-grow: 1">
                        {{
                          sharedDataService.data.user_type == 1
                            ? "My Client List"
                            : "My Workspaces"
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="tabs">
                    <a
                      [ngClass]="{ active: clientFilter == 'ACTIVE' }"
                      (click)="setClientFilter('ACTIVE')"
                      >Active</a
                    >
                    <a
                      [ngClass]="{
                        active: clientFilter == 'UNREAD',
                        'has-messages':
                          dashboardStore.unreadConversationsCount() > 0,
                      }"
                      (click)="setClientFilter('UNREAD')"
                      style="position: relative; padding-right: 24px"
                    >
                      Unread
                      <div class="badges">
                        <div class="messages" title="Unread">
                          {{ dashboardStore.unreadConversationsCount() }}
                        </div>
                      </div>
                    </a>
                    @if (data.user_type == 1) {
                      <a
                        [ngClass]="{ active: clientFilter == 'ARCHIVED' }"
                        (click)="setClientFilter('ARCHIVED')"
                        >Archived</a
                      >
                    }
                  </div>
                </div>
                <div
                  class="sidebar-clients-list"
                  [ngClass]="{ 'component-loading': loadings['client_list'] }"
                >
                  @if (dashboardStore.clients.length > 0) {
                    <div class="clients-list-list">
                      @for (
                        c of dashboardStore.clients;
                        track trackClient($index, c)
                      ) {
                        <div style="padding: 0 10px">
                          @if (
                            clientFilter == "ACTIVE"
                              ? !c.archived
                              : clientFilter == "ARCHIVED"
                                ? c.archived
                                : clientFilter == "UNREAD"
                                  ? !c.archived && !c.company_conversation.read
                                  : null
                          ) {
                            <a
                              [routerLink]="['workspaces', c.id]"
                              preserveFragment="true"
                              [routerLinkActiveOptions]="{ exact: false }"
                              [title]="c.name"
                              [ngClass]="{
                                active:
                                  c.company_conversation.uuid ==
                                    dashboardStore.activeConversationUUID &&
                                  isRouteOnWorkspaces,
                              }"
                            >
                              <div class="client-name">{{ c.name }}</div>
                              <div class="badges">
                                <div
                                  class="messages"
                                  title="Unread messages"
                                  [hidden]="c['company_conversation'].read"
                                ></div>
                                <div
                                  class="notifications-indicator"
                                  title="Unread notifications"
                                  [hidden]="
                                    !c['company_conversation']
                                      ?.has_notifications
                                  "
                                ></div>
                                <!-- <div class="tracked-items" title="Open client tasks">{{c.open_tracked_items}}</div> -->
                              </div>
                            </a>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <ng-template #extension>
            @if (selectedFilterTags.length > 0) {
              <h4 style="font-size: 20px">Selected tags:</h4>
            }
            @if (selectedFilterTags.length > 0) {
              <p style="font-size: 14px">
                Show items with
                <b>{{
                  andOrFilter == "and"
                    ? "all"
                    : andOrFilter == "or"
                      ? "any"
                      : "none"
                }}</b>
                of these tags:
              </p>
            }
            @for (tag of selectedFilterTags; track tag) {
              <ch-tag
                [name]="tag.name"
                [color]="tag.color"
                (click)="removeTagFromFilter(tag)"
              ></ch-tag>
            }
            @if (selectedFilterTags.length > 0) {
              <div>
                <hr />
                <button class="btn btn-default" (click)="clearFilter()">
                  Clear
                </button>
              </div>
            }
          </ng-template>
          <ng-template #icon>
            <div class="tag-add" tooltip="Filter by tags">
              @if (selectedFilterTags.length == 0) {
                <i class="tio-filter_outlined" style="opacity: 0.6"></i>
              }
              @if (selectedFilterTags.length > 0) {
                <i class="tio-filter"></i>
              }
            </div>
          </ng-template>
          <!-- Accountant workspace list only -->
          @if (sharedDataService.data.user_type == 1) {
            <div
              class="sidebar-clients-list"
              [ngClass]="{
                'component-loading': loadings['client_list'],
                archived: clientFilter == 'ARCHIVED',
              }"
            >
              <div class="clients-list-header">
                <div class="title">
                  <div class="text d-flex">
                    <div style="flex-grow: 1">
                      {{
                        sharedDataService.data.user_type == 1
                          ? "My Client List"
                          : "My Workspaces"
                      }}
                    </div>
                    <div
                      (click)="toggleClientList()"
                      class="collapse-client-list"
                    >
                      <i
                        class="tio tio-first_page"
                        tooltip="Collapse Client List"
                        placement="right"
                      ></i>
                    </div>
                  </div>
                </div>
                <div
                  class="sidebar-search-clients"
                  [ngClass]="{
                    'full-width': sharedDataService.subscriptionType == 'free',
                  }"
                >
                  @if (sharedDataService.data.user_type == 1) {
                    <label class="search-clients">
                      <i class="feather search"></i>
                      <input
                        id="search-clients"
                        type="text"
                        placeholder="Search"
                        autocomplete="off"
                        aria-autocomplete="none"
                        list="autocompleteOff"
                        autocorrect="off"
                        spellcheck="false"
                      />
                      <i class="feather x-circle"></i>
                    </label>
                  }
                  @if (
                    sharedDataService.subscriptionType == "paid" ||
                    sharedDataService.subscriptionType == "premium"
                  ) {
                    <div>
                      @if (!batch_client_tasks) {
                        <div
                          class="batch-client-tasks-icon"
                          (click)="toggleBatchClientTasks(true)"
                          tooltip="Batch Actions"
                        >
                          <i class="tio tio-checkmark_square_outlined"></i>
                        </div>
                      }
                      @if (batch_client_tasks) {
                        <div
                          class="batch-client-tasks-icon cancel"
                          (click)="toggleBatchClientTasks(false)"
                          tooltip="Cancel"
                        >
                          <i class="tio tio-clear"></i>
                        </div>
                      }
                    </div>
                  }
                  <ch-tag-add
                    class="sidebar-tag-add"
                    #tagList
                    [removeTagOnClick]="false"
                    [extension]="extension"
                    (tagClick)="addTagToFilter($event)"
                    (andOrFilterChanged)="changeAndOrFilter($event)"
                    [icon]="icon"
                    [autoClose]="true"
                  ></ch-tag-add>
                </div>
                <div class="tabs">
                  <a
                    [ngClass]="{ active: clientFilter == 'ACTIVE' }"
                    (click)="setClientFilter('ACTIVE')"
                    style="margin-right: 10px"
                    >Active</a
                  >
                  <a
                    [ngClass]="{
                      active: clientFilter == 'UNREAD',
                      'has-messages':
                        dashboardStore.unreadConversationsCount() > 0,
                    }"
                    (click)="setClientFilter('UNREAD')"
                    style="
                      position: relative;
                      padding-right: 46px;
                      margin-right: 10px;
                    "
                  >
                    Unread
                    <div class="badges">
                      <div class="messages" title="Unread">
                        {{
                          selectedFilterTags.length == 0
                            ? dashboardStore.unreadConversationsCount()
                            : filterClientsByTagAndUnread(
                                dashboardStore.clients
                              ).length
                        }}
                      </div>
                      <div class="messages badge-bell" title="Unread">
                        {{ dashboardStore.notificationsCount() }}
                      </div>
                    </div>
                  </a>
                  @if (sharedDataService.data.user_type == 1) {
                    <a
                      [ngClass]="{ active: clientFilter == 'ARCHIVED' }"
                      (click)="setClientFilter('ARCHIVED')"
                      >Archived</a
                    >
                  }
                </div>
              </div>
              @if (
                dashboardStore.clients.length == 0 &&
                sharedDataService.subscriptionType != "free"
              ) {
                <div
                  class="clients-list-list"
                  [ngClass]="{ batch: batch_client_tasks }"
                >
                  <h4 style="margin-top: 15px; font-size: 18px">
                    No clients to view
                  </h4>
                  <p>
                    Please have an Admin in your Practice assign you clients.
                  </p>
                </div>
              }
              @if (dashboardStore.clients.length > 0) {
                <div
                  class="clients-list-list"
                  [ngClass]="{ batch: batch_client_tasks }"
                >
                  @for (
                    c of dashboardStore.clients
                      | clientTagSearch: selectedFilterTags : andOrFilter;
                    track trackClient($index, c)
                  ) {
                    <div style="padding: 0 10px">
                      @if (
                        clientFilter == "ACTIVE"
                          ? !c.archived
                          : clientFilter == "ARCHIVED"
                            ? c.archived
                            : clientFilter == "UNREAD"
                              ? !c.archived &&
                                (!c.company_conversation?.read ||
                                  c.company_conversation?.has_notifications ==
                                    true)
                              : null
                      ) {
                        <a
                          [title]="c.name"
                          [ngClass]="{
                            active:
                              c.company_conversation?.uuid ==
                                dashboardStore.activeConversationUUID &&
                              isRouteOnWorkspaces,
                          }"
                          (click)="
                            $event.stopPropagation(); selectConversation(c.id)
                          "
                        >
                          @if (batch_client_tasks) {
                            <label class="task-checkbox">
                              <input
                                type="checkbox"
                                value="option1"
                                [checked]="isConversationSelected(c.id)"
                              />
                              <div
                                class="custom-checkbox"
                                (click)="selectConversation(c.id)"
                              ></div>
                            </label>
                          }
                          <div class="client-name">
                            {{ c.name }}
                          </div>
                          <div class="badges">
                            <div
                              class="messages"
                              title="Unread messages"
                              [hidden]="c.company_conversation?.read"
                            ></div>
                            @if (c["company_conversation"]?.has_notifications) {
                              <div
                                class="notifications-indicator"
                                title="Unread notifications"
                              ></div>
                            }
                            <!-- <div class="tracked-items" title="Open client tasks">{{c.open_tracked_items}}</div> -->
                          </div>
                        </a>
                      }
                    </div>
                  }
                </div>
              }
              @if (
                sharedDataService.data.user_type == 1 && !batch_client_tasks
              ) {
                <div class="sidebar-add-user">
                  <button
                    class="btn btn-primary"
                    (click)="openAddClientModal(null)"
                  >
                    <i class="tio-user_add"></i>
                    Add New Client
                  </button>
                </div>
              }
              @if (
                sharedDataService.data.user_type == 1 && batch_client_tasks
              ) {
                <div class="sidebar-add-user">
                  <button
                    class="btn btn-primary-light"
                    style="margin-bottom: 8px"
                    (click)="selectAllConversations()"
                  >
                    <i class="tio-checkmark_square_outlined"></i>
                    Select / Unselect All
                  </button>
                  <button
                    [disabled]="!selectedConversationIds.length"
                    class="btn btn-primary"
                    style="margin-bottom: 8px"
                    (click)="launchClientTaskModal()"
                  >
                    <i class="tio-add"></i>
                    Client Task
                  </button>
                  <button
                    [disabled]="!selectedConversationIds.length"
                    style="margin-bottom: 8px"
                    class="btn btn-primary"
                    (click)="launchJobPickerModal()"
                  >
                    <i class="tio-add"></i>
                    Job
                  </button>
                  <button
                    class="btn btn-primary"
                    (click)="launchMessageModal()"
                    [disabled]="!selectedConversationIds.length"
                  >
                    <i class="tio-add"></i>
                    Message
                  </button>
                </div>
              }
            </div>
          }
          @if (sharedDataService.data.user_type == 2) {
            <div class="user-dropdown-wrapper">
              <div
                dropdown
                [dropup]="true"
                [autoClose]="true"
                [insideClick]="true"
              >
                <div dropdownToggle class="dropdown-toggle">
                  <div class="d-flex align-items-center">
                    <div class="user-dropdown-avatar-wrapper">
                      <div class="bubble-avatar">
                        <div class="avatar avatar-48">
                          <div
                            class="avatar"
                            [style.background-image]="
                              'url(' + user.pictureUrl + ')'
                            "
                            style="
                              background-size: contain;
                              background-position: center;
                              width: 100%;
                              height: 100%;
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="user-dropdown-name-wrapper">
                      <div class="practice-user-top-info-name">
                        {{ user.first_name }}
                      </div>
                      <div class="practice-user-top-info-practice">
                        {{ company.name }}
                      </div>
                    </div>
                    <div class="user-dropdown-icon-wrapper">
                      <i class="feather more-horizontal gray-icon"></i>
                    </div>
                  </div>
                </div>
                <ul
                  *dropdownMenu
                  class="dropdown-menu dropdown-menu-end dropown-user-sidebar"
                  role="menu"
                >
                  <li>
                    <a (click)="openMyAccountModal()"
                      ><i class="feather user"></i> My Account</a
                    >
                  </li>
                  <li>
                    <a (click)="openMyDevicesModal()"
                      ><i class="feather smartphone"></i> My Devices</a
                    >
                  </li>
                  <li>
                    <a (click)="openGeneralNotificationSettingsModal()">
                      <i class="feather bell"></i> Notification Settings
                    </a>
                  </li>
                  <li role="separator" class="divider"></li>
                  <li>
                    <a (click)="logout()"
                      ><i class="feather log-out"></i> Logout</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="sidebar-backdrop" (click)="menuOpen = !menuOpen"></div>
    <div
      class="practice-content-wrapper"
      [ngClass]="{ 'client-view': sharedDataService.data.user_type == 2 }"
    >
      <div class="container-fluid" style="height: 100%">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<ng-template #trialEnding>
  <div class="modal-header text-center" style="border-bottom: none">
    <i class="feather credit-card x3" style="color: #e33b4d"></i>
    <h4>Trial Ended</h4>
    <p>
      Please proceed to the <a routerLink="practice-info">Pratice Info</a> and
      add a payment method in order to continue using Client Hub.
    </p>
  </div>
</ng-template>

<ng-template #welcomeVideo>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="bsModalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title">Welcome Video</h4>
  </div>

  <div class="modal-body">
    <div
      class="wistia_embed wistia_async_v8fqpl7x1t"
      style="height: 500px; width: 100%"
    >
      &nbsp;
    </div>
  </div>
</ng-template>

@if (app_discovery != false) {
  <div class="tour-modal-wrapper">
    <div class="tour-modal">
      <div class="row d-flex align-items-center text-left">
        <div class="col-sm-6 col-md-5">
          <h4 style="font-size: 22px; font-weight: 900">
            Mobile App for iOS and Android available!
          </h4>
          <p style="margin-bottom: 30px">
            Scan the QR Code below, install the app and start exchanging
            messages and files from anywhere.
          </p>
          <img style="max-width: 130px" src="assets/img/qrcode.png" />
          <p style="font-size: 12px; margin-top: 15px">
            Or access
            <a routerLink="/install" target="_blank" rel="noreferrer noopener"
              ><strong>clienthub.app/#/install</strong></a
            >
            from your mobile device.
          </p>
        </div>
        <div class="col-sm-6 col-md-7 tour-modal-right-column">
          <div class="mockup">
            <img class="img-responsive" src="assets/img/mockup.png" />
          </div>
        </div>
      </div>
      <i class="feather x" (click)="skipAppDiscovery()"></i>
    </div>
    <div class="tour-modal-backdrop"></div>
  </div>
}

<div class="help-reamaze" [ngClass]="{ display: openHelp }">
  <div class="text-right">
    <i class="feather x" (click)="openHelp = !openHelp"></i>
  </div>
  <div data-reamaze-embed="kb"></div>
</div>

<app-client-tasks
  [conversation]="dashboardStore.currentCompany?.company_conversation"
></app-client-tasks>

<!-- Job modal -->
@if (showJobModal == true) {
  <div class="job-modal" [ngClass]="{ open: showJobModal == true }">
    <div class="modal-close" (click)="closeJobDrawer()">
      <i class="feather x"></i>
    </div>
    <!-- Job content -->
    <app-job-content [job]="job"></app-job-content>
  </div>
}
<div class="job-modal-backdrop" (click)="closeJobDrawer()"></div>

@if (genericDrawerService.showDrawer) {
  <ch-drawer></ch-drawer>
}
